<div class="overLayDiv active"></div>
<div id="rightSideBar">
    <div class="rightSidePanel w-70pc active">
        <header class="panel-header">
            <div class="viewDemo title-and-video">
                <h2>{{ "item_for_approval_as_an_approver" | translate }}</h2>
            </div>
            <div class="panel-left-btn">
                <button type="button" class="btn eod-btn-outline-warning" (click)="fnClosePanel()">
                    {{ 'label_close' | translate }}
                </button>
            </div>
        </header>
        <div class="eod-panel-body">
            <div class="block heightCalc-5">
                <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12 no-padding-right-left heightCalc-10">
                    <!----------------------Start Grid--------------------------->
                    <app-grid [columns]="gridColumnDefs" [data]="fmAsApproverSummary"
                        [gridConfigItems]="gridConfigItems" (onCellClick)="fnOnGridCellClick($event)">
                    </app-grid>
                    <!----------------------End Grid--------------------------->
                </div>
            </div>
        </div>
    </div>
</div>

<employee-status-panel [hidden]="!showApproverStatusPanel" (closePanel)="showApproverStatusPanel = false"
    [employeesList]="employeesList" [costCentre]="approverListCostCentre" [costCentreCode]="approverListCostCentreCode"
    [costCentreId]="approverListCostCentreId" [itemType]="panelItemType">
</employee-status-panel>

<assign-approver-panel [(selectedItems)]="selectedCostCentres" *ngIf="selectedCostCentres.length > 0"
    (closePanel)="closeAssignPanel($event)" [columnDefinitions]="assignApproversGridColumnDefs" [itemType]="2">
</assign-approver-panel>